/**
 * Unit conversion constants for the CHE 334 Virtual Pumping System Lab.
 *
 * All factors convert FROM the first unit TO the second unit.
 * e.g.  value_ft = value_m * M_TO_FT
 */

/** Metres → feet */
export const M_TO_FT = 3.28084;

/** Watts → horsepower */
export const W_TO_HP = 1 / 745.699;

/** m³/s → US gallons per minute */
export const M3S_TO_GPM = 15850.3;

/** kPa → psi */
export const KPA_TO_PSI = 0.145038;

/** Reynolds number below which flow is laminar (Moody chart) */
export const RE_LAMINAR = 2300;
